import React, { useState, useEffect } from "react";
import "./viewDetailsModalNew.scss";
import {
  disableHelpButton,
  enableHelpButton,
} from "../../common/DisableHelpButton/DisableHelpButton";
import AlertMsgPopup from "../AlertMsgPopup/index";
import {
  GET_APPOINTMENT_DETAILS,
  GET_OR_SEND_OTP,
  GET_VERIFICATION_REQUEST,
  UPDATE_DEMOGRAPHIC_DETAILS,
  VERIFY_OTP,
} from "./ViewDetailsApiHandler/apiConstants";
import Loader from "../../UI Component/Loader/Loader";
import ConfirmPatientIdentityModal from "./ConfirmPatientIdentityModal";
import AbhaPatientDetailsModal from "./AbhaPatientDetailsModal";
import { ABHA_VERIFICATION_OPTIONS } from "./constant";
import ViewDetailsMainModal from "./ViewDetailsMainModal";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";

export default function ViewDetailsModalNew(props) {
  const {
    openView,
    closeView,
    appointment,
    appointment_id,
    appointment_status,
    appointmentJourney,
    editUhid,
    handleCloseEditUhid,
  } = props;
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState();
  const [editMode, setEditMode] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);

  const [openViewDetailsPopup, setOpenViewDetailsPopup] = useState(false);
  const [verificationPopUp, setVerificationPopup] = useState(false);
  const [selectedVerificationOption, setSelectedVerificationOption] =
    useState("");
  const [otpResponseStatus, setOtpResponseStatus] = useState("");
  const [patientDetailsStatus, setPatientDetailsStatus] = useState("pending");
  const [showOtpPopUp, setShowOtpPopUp] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [abhPatientDetails, setAbhaPatientDeatils] = useState({});
  const [showPatientDetailsPopup, setShowPatientDetailsPopup] = useState(false);
  const [verificationError, setVerificationError] = useState();
  const otpVerificationOption = ABHA_VERIFICATION_OPTIONS;

  // <===
  useEffect(() => {
    setOpenViewDetailsPopup(openView);
    if (openView) {
      disableHelpButton();
      setLoading(true);
      fetchAppointmentDetails();
    }
    return () => {
      enableHelpButton();
    };
  }, [openView]);

  const fetchAppointmentDetails = () => {
    let reqPayload = { appointment_id: appointment_id, masking: props.masking };

    let resData = c2cPostApiHandler(GET_APPOINTMENT_DETAILS, reqPayload);

    resData.then(([res, err]) => {
      setLoading(false);
      setPageLoader(false);
      setEditMode(false);
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setAppointmentDetails(res.data?.appointment_details);
          if (editUhid) {
            setEditMode(true);
            handleCloseEditUhid();
          }
        }
      }
    });
  };

  const handleAbhaVerificationOption = (selectedValue) => {
    setVerificationError("");
    setOtpResponseStatus("");
    setPatientDetailsStatus("");
    setSelectedVerificationOption(selectedValue?.value);
    getVerificationRequestAPICall(selectedValue?.value, false);
  };
  const getVerificationRequestAPICall = (auth_mode, isResendOtp) => {
    if (!isResendOtp) {
      setVerificationPopup(false);
      setPageLoader(true);
    }
    let requestPayload = {
      appointment_id: appointment_id,
      auth_mode: auth_mode,
      abdm_hfr_id: appointmentDetails?.abdm_hfr_id,
      preferred_abha_address: appointmentDetails?.preferred_abha_address,
      auth_type: "abha-address",
    };

    const requestIdResponse = c2cPostApiHandler(
      GET_VERIFICATION_REQUEST,
      requestPayload
    );
    requestIdResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          // let payload = {
          //   request_id: res?.data?.request_id,
          //   request_type: "request_otp",
          //   patient_account_id: appointmentDetails?.patient_account_id,
          // };
          // if (isResendOtp) {
          //   resendOTPAPICall(payload);
          // } else {
          //   getOrSendOTPAPICall(payload);
          // }
          setTransactionId(res?.data?.transaction_id);
          setShowOtpPopUp(true);
          setPageLoader(false);
        } else if (res?.data?.statusCode === 503) {
          if (isResendOtp) {
            setShowOtpPopUp(false);
          }
          setPageLoader(false);
          setVerificationError(res?.data?.message);
          setVerificationPopup(true);
        } else {
          if (isResendOtp) {
            setShowOtpPopUp(false);
          }
          handleOpenVerifyPopup();
        }
      } else {
        if (isResendOtp) {
          setShowOtpPopUp(false);
        }
        handleOpenVerifyPopup();
      }
    });
  };
  const resendOTPAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      setOtpResponseStatus("");
      setShowOtpPopUp(false);
      handleOpenVerifyPopup();
    }, 20000);

    if (otpResponseStatus !== "complete") {
      interval = setInterval(() => {
        const otpResponse = c2cPostApiHandler(GET_OR_SEND_OTP, payload);
        otpResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setOtpResponseStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                setTransactionId(res?.data?.transaction_id);
                clearInterval(timer);
                clearInterval(interval);
                changeOTPStatus();
              }
            }
          }
        });
      }, 1000);
    }
  };
  const getOrSendOTPAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      handleOpenVerifyPopup();
      setOtpResponseStatus("");
    }, 20000);

    if (otpResponseStatus !== "complete") {
      interval = setInterval(() => {
        const otpResponse = c2cPostApiHandler(GET_OR_SEND_OTP, payload);
        otpResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setOtpResponseStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                setTransactionId(res?.data?.transaction_id);
                setPageLoader(false);
                setShowOtpPopUp(true);
                clearInterval(timer);
                clearInterval(interval);
                changeOTPStatus();
              }
            }
          }
        });
      }, 1000);
    }
  };
  const handleOpenVerifyPopup = () => {
    setPageLoader(false);
    setVerificationError("OTP verification failed. Please try again");
    setVerificationPopup(true);
  };
  const changeOTPStatus = () => {
    setTimeout(() => {
      setOtpResponseStatus("");
    }, 2000);
  };
  const handleCloseVerificationPopup = () => {
    setOtpResponseStatus("");
    setVerificationPopup(false);
    setOpenViewDetailsPopup(true);
  };
  const handleCloseOtpPopup = () => {
    setOtpResponseStatus("");
    setShowOtpPopUp(false);
    setOpenViewDetailsPopup(true);
  };

  const handleVerifyOTP = () => {
    let payload = {
      appointment_id: appointment_id,
      auth_code: otpInput,
      transaction_id: transactionId,
      auth_mode: selectedVerificationOption,
      auth_type: "abha-address",
    };

    verifyOtpAPICall(payload);
  };

  const handleConfirmYes = () => {
    let payload = {
      patient_account_id: appointmentDetails?.patient_account_id,
      gender: abhPatientDetails?.gender,
      name: abhPatientDetails?.name,
      dob: abhPatientDetails?.dob,
      appointment_id: appointment_id,
    };
    updateDemogtaphicDetailsAPICall(payload);
  };

  const handleConfirmNo = () => {
    setShowPatientDetailsPopup(false);
    closeView();
  };

  const handleResendOTP = () => {
    setOtpResponseStatus("");
    getVerificationRequestAPICall(selectedVerificationOption, true);
  };

  const updateDemogtaphicDetailsAPICall = (payload) => {
    const demographicDetailsResponse = c2cPostApiHandler(
      UPDATE_DEMOGRAPHIC_DETAILS,
      payload
    );
    demographicDetailsResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setShowPatientDetailsPopup(false);
          closeView();
        } else {
          setShowPatientDetailsPopup(false);
          handleOpenVerifyPopup();
        }
      } else {
        setShowPatientDetailsPopup(false);
        handleOpenVerifyPopup();
      }
    });
  };
  const verifyOtpAPICall = (payload) => {
    setShowOtpPopUp(false);
    setPageLoader(true);
    const verifyOtpResponse = c2cPostApiHandler(VERIFY_OTP, payload);
    verifyOtpResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          if (res?.data?.request_id) {
            // let reqPayload = {
            //   request_id: res?.data?.request_id,
            //   request_type: "verify_otp",
            //   patient_account_id: appointmentDetails?.patient_account_id,
            // };
            // getAbhaDetailsAPICall(reqPayload);

            let details = {
              ...res?.data?.data,
              name: res?.data?.data?.fullName,
              gender:
                res?.data?.data?.gender?.toLowerCase() === "m"
                  ? "Male"
                  : res?.data?.data?.gender?.toLowerCase() === "f"
                  ? "Female"
                  : res?.data?.data?.gender,
              dob:
                res?.data?.data?.yearOfBirth +
                "-" +
                res?.data?.data?.monthOfBirth +
                "-" +
                res?.data?.data?.dayOfBirth,
            };
            setAbhaPatientDeatils(details);
            setPageLoader(false);
            setShowPatientDetailsPopup(true);
          }
        } else {
          handleOpenVerifyPopup();
        }
      } else {
        handleOpenVerifyPopup();
      }
    });
  };
  const getAbhaDetailsAPICall = (payload) => {
    let interval;
    const timer = setTimeout(() => {
      clearInterval(interval);
      setOtpResponseStatus("");
      handleOpenVerifyPopup();
    }, 20000);

    if (patientDetailsStatus !== "complete") {
      interval = setInterval(() => {
        const patientDetailsResponse = c2cPostApiHandler(
          GET_OR_SEND_OTP,
          payload
        );
        patientDetailsResponse.then(([res, err]) => {
          if (!err) {
            if (res?.data?.statusCode === 200) {
              setPatientDetailsStatus(res?.data?.status);
              if (res?.data?.status === "complete") {
                clearInterval(interval);
                clearInterval(timer);
                let details = {
                  ...res?.data?.patient_details,
                  gender:
                    res?.data?.patient_details?.gender?.toLowerCase() === "m"
                      ? "Male"
                      : res?.data?.patient_details?.gender?.toLowerCase() ===
                        "f"
                      ? "Female"
                      : res?.data?.patient_details?.gender,
                  dob:
                    res?.data?.patient_details?.yearOfBirth +
                    "-" +
                    res?.data?.patient_details?.monthOfBirth +
                    "-" +
                    res?.data?.patient_details?.dayOfBirth,
                };
                setAbhaPatientDeatils(details);
                setPageLoader(false);
                setShowPatientDetailsPopup(true);
                setTimeout(() => {
                  setOtpResponseStatus("");
                }, 2000);
              }
            }
          }
        });
      }, 1000);
    }
  };
  return (
    <>
      {pageLoader && <Loader />}
      {openAlert && <AlertMsgPopup alertMsg={alertMsg} />}
      {openViewDetailsPopup && (
        <ViewDetailsMainModal
          loading={loading}
          appointment={appointment}
          closeView={closeView}
          openViewDetailsPopup={openViewDetailsPopup}
          appointmentDetails={appointmentDetails}
          appointment_id={appointment_id}
          editMode={editMode}
          appointmentJourney={appointmentJourney}
          appointment_status={appointment_status}
          editUhid={editUhid}
          setEditMode={setEditMode}
          fetchAppointmentDetails={fetchAppointmentDetails}
          setOpenAlert={setOpenAlert}
          setAlertMsg={setAlertMsg}
          setPageLoader={setPageLoader}
          setOpenViewDetailsPopup={setOpenViewDetailsPopup}
          setVerificationError={setVerificationError}
          setVerificationPopup={setVerificationPopup}
        />
      )}

      {verificationPopUp && (
        <ConfirmPatientIdentityModal
          otpVerificationOption={otpVerificationOption}
          verificationError={verificationError}
          handleAbhaVerificationOption={handleAbhaVerificationOption}
          handleCloseVerificationPopup={handleCloseVerificationPopup}
        />
      )}

      {showOtpPopUp && (
        <ConfirmPatientIdentityModal
          contentType={"otp"}
          selectedVerificationOption={selectedVerificationOption}
          handleCloseVerificationPopup={handleCloseOtpPopup}
          otpInput={otpInput}
          handleOTPChange={(otp) => setOtpInput(otp)}
          handleResendOTP={handleResendOTP}
          handleVerifyOtp={handleVerifyOTP}
        />
      )}

      {showPatientDetailsPopup && (
        <AbhaPatientDetailsModal
          appointmentDetails={appointmentDetails}
          abhPatientDetails={abhPatientDetails}
          handleYes={handleConfirmYes}
          handleNo={handleConfirmNo}
        />
      )}
    </>
  );
}
